(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('PermissionService', PermissionService);

    function PermissionService(lodash) {
        return function() {
            let model = defaultModel();
            return {
                toggle: toggle,
                initModel: initModel,
                getModel: getModel,
                getModelReadOnly: getModelReadOnly,
                initItem: initItem,
            };

            function toggle(item) {
                const path = ['permissions', item.select_id, 'value'].join('.');
                lodash.set(model, path, !lodash.get(model, path, false));
            }

            function initModel(m) {
                model = m || defaultModel();
            }

            function getModel(item) {
                if (!item) {
                    return model;
                }
                return lodash.get(model, ['permissions', item.select_id, 'value'].join('.'), false);
            }

            function getModelReadOnly(item) {
                if (!item) {
                    return model;
                }
                return lodash.get(model, ['permissions', item.select_id, 'readonly'].join('.'), false);
            }

            function initItem(item) {
                const path = ['permissions', item.select_id, 'value'].join('.');
                if (!lodash.has(model, path)) {
                    lodash.set(model, path, false);
                }
            }

            function defaultModel() {
                return {
                }
            }
        };
    }
})();